import { t } from '@lingui/macro'
import { LinkType, MenuLink } from '../../menuLink/MenuLink'
import { LinkTarget } from 'interfaces/LinkTarget.interface'
import { getTermsLink } from '../getTermsLink'

export const getLinks = (language?: string): MenuLink[] => [
  {
    type: LinkType.AnchorTag,
    link: 'https://www.solidsport.com',
    translationText: t`About us`,
    linkTarget: LinkTarget.NewWindow
  },
  {
    type: LinkType.Route,
    link: '/calendar',
    translationText: t`Schedule`
  },
  {
    type: LinkType.AnchorTag,
    link: 'https://solidsport.freshdesk.com/en/support/home',
    translationText: t`Support`,
    linkTarget: LinkTarget.NewWindow
  },
  {
    type: LinkType.AnchorTag,
    link: getTermsLink(language),
    translationText: t`Terms`,
    linkTarget: LinkTarget.NewWindow
  },
  {
    type: LinkType.AnchorTag,
    link: 'https://jobs.solidsport.com/',
    translationText: t`Jobs`,
    linkTarget: LinkTarget.NewWindow
  }
]
